import { render, staticRenderFns } from "./ServerErrors.vue?vue&type=template&id=4cbf6c55&"
import script from "./ServerErrors.vue?vue&type=script&lang=js&"
export * from "./ServerErrors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ServerErrors.vue"
export default component.exports